import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {Owner} from "../../model/customer/owner";
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearCustomerBackUrl} from "../config/crystalclear-customer-back-url";
import {ParentAPIService} from "../parent.api.service";
import {Observable} from "rxjs";
import {ApiValidation} from "../../model/api/api-validation";
import {FieldResult} from "../../model/api/field-result";
import {CrystalclearInternalBackUrl} from "../config/crystalclear-internal-back-url";
import {CrystalclearExchangeBackUrl} from "../config/crystalclear-exchange-back-url";
import {Contract} from "../../model/exchange/contract";
import {Order} from "../../model/clearing/order";
import {ExchangeDetail} from "../../model/exchange/exchange-detail";

@Injectable({
  providedIn: 'root'
})
export class ExchangeContractService extends CommonCrudService<Contract> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearExchangeBackUrl.GET_EXCHANGE_CONTRACT_LIST,
      CrystalclearExchangeBackUrl.SAVE_EXCHANGE_CONTRACT,
      CrystalclearExchangeBackUrl.DELETE_EXCHANGE_CONTRACT);
  }

  public getForIdParts(contractIdParts: string[]): Observable<ApiValidation<Contract[]>> {
    return this.post(CrystalclearExchangeBackUrl.POST_EXCHANGE_CONTRACT_GET, contractIdParts);
  }

  public getContractIdPart(order: any) {
    return order.exchangeCode + '-' + order.contractCode + '-' + (order.strike != 0 ? 'O' : 'F');
  }
}
